<template>
  <section>
    <br>
    <h1 class="title">
      {{ $root.pageTitle }}
    </h1>
    <div class="columns">
      <div class="column is-12 is-paddingless has-text-centered">
        <br>
        <img
          src="/assets/img/access-denied.png"
          alt="Access denied"
        >
        <br>
        <p>Seems you are not authorized to access this page</p>

        <p>
          <a
            class="button primary"
            href="/"
          >Go to Homepage</a>
        </p>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'PageForbidden',
  data() {
    return {
      info: null
    };
  },
  mounted() {
    this.$root.pageTitle = 'Your access forbidden for this page';
  }
};
</script>
<style scoped>
    img {
        width: 100%;
        max-width: 250px;
        margin: 2rem 0;
    }
    h1.title {
        text-align: center;
    }
</style>
